var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.322,
    height: 16.656,
    viewBox: "0 0 18.322 16.656",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_72164",
    "data-name": "Path 72164",
    d: "M10.161,10.816l3.533,3.533-1.178,1.178L10.994,14v4.651H9.328V14L7.805,15.527,6.628,14.349Zm0-8.816a5.831,5.831,0,0,1,5.791,5.158,4.581,4.581,0,0,1-.794,8.981V14.462a2.915,2.915,0,0,0-.417-5.8,2.869,2.869,0,0,0-.509.045A4.164,4.164,0,1,0,6,7.83a4.129,4.129,0,0,0,.093.877,2.915,2.915,0,0,0-1.076,5.73l.15.025v1.676a4.581,4.581,0,0,1-.794-8.98A5.83,5.83,0,0,1,10.161,2Z",
    transform: "translate(-1 -2)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImg);
export default __webpack_public_path__ + "static/media/upload_img.1cd3a123923c6c26c477b40f726a21bf.svg";
export { ForwardRef as ReactComponent };